

























import Base from "@/controllers/base.ts";
import { Component } from "vue-property-decorator";
import { Pagination } from "ant-design-vue";
import CList from "@/components/CList/index.vue";

@Component({
  name: "Notice",
  components: {
    CList,
    APagination: Pagination
  }
})
export default class Notice extends Base {
  private pageNum = 1;
  private total = 0;
  private pageSize = 10;
  private dataSource: any[] = [];
  private searchValue = "";

  private created() {
    this._created();
    this.getList();
  }

  private async getList() {
    const res = await this.$api.NoticeList({
      pageNum: this.pageNum,
      pageSize: this.pageSize
    });
    if (res && res.code === 200) {
      this.total = res.total;
      this.dataSource = res.rows;
    }
  }

  private goSearch() {
    // undo
  }

  private onChange() {
    this.getList();
  }

  private onShowSizeChange() {
    this.pageNum = 1;
    this.getList();
  }
}
